import { useTranslations } from '@vocab/react';
import { Box, Button } from 'braid-design-system';

import translations from './.vocab';

import * as styles from './CommentCTA.css';

interface CommentCTAProps {
  onClick?: () => void;
}

export default ({ onClick }: CommentCTAProps) => {
  const { t } = useTranslations(translations);

  return (
    <Box className={styles.secondaryTone}>
      <Button variant="ghost" onClick={onClick} size="small">
        {t('threadReply')}
      </Button>
    </Box>
  );
};
